@if (navigationItem().externalLink) {
  <button type="button" class="navigation-external-link__link" (click)="openExternalLink()">
    <ng-template *ngTemplateOutlet="linkContent" />
  </button>
}

@if (navigationItem().ssoTargetPage; as ssoTargetPage) {
  <button
    type="button"
    class="navigation-external-link__sso-link"
    [itcOpenSsoLink]="ssoTargetPage"
    [isLoading$]="isLoading$"
    [cancelOnDestroy]="false"
    [linkId]="navigationItem().id"
  >
    <ng-template *ngTemplateOutlet="linkContent" />
  </button>
}

@if (navigationItem().ssoSalesforceDestination; as ssoSalesforceDestination) {
  <button
    type="button"
    class="navigation-external-link__sso-link"
    [itcOpenSsoSalesforceLink]="ssoSalesforceDestination"
    [isLoading$]="isLoading$"
    [cancelOnDestroy]="false"
    [linkId]="navigationItem().id"
  >
    <ng-template *ngTemplateOutlet="linkContent" />
  </button>
}

@if (navigationItem().ssoCertifyTaxLink) {
  <button
    type="button"
    class="navigation-external-link__sso-link"
    itcOpenSsoCertifyTaxLink
    [isLoading$]="isLoading$"
    [cancelOnDestroy]="false"
    [linkId]="navigationItem().id"
  >
    <ng-template *ngTemplateOutlet="linkContent" />
  </button>
}

@if (navigationItem().ssoDeepLink; as ssoDeepLink) {
  <button
    type="button"
    class="navigation-external-link__sso-link"
    [itcOpenSsoDeepLink]="ssoDeepLink"
    [isLoading$]="isLoading$"
    [cancelOnDestroy]="false"
    [linkId]="navigationItem().id"
  >
    <ng-template *ngTemplateOutlet="linkContent" />
  </button>
}

<ng-template #linkContent>
  @if (isLoading$ | async) {
    <div class="navigation-external-link__spinner">
      <kds-spinner variant="overlay" />
    </div>
  }
  <div class="navigation-external-link__regular-link">
    <itc-navigation-link
      [iconClass]="navigationItem().iconClass"
      [linkName]="'navigation.items.' + navigationItem().id | translate"
      [isTooltipEnabled]="isTooltipEnabled()"
    />
    @if (!isTooltipEnabled()) {
      <i aria-hidden="true" class="navigation-external-link__external-icon fa-regular fa-external-link"></i>
    }
  </div>
</ng-template>
